<template>
    <div class="test">
        <span>this is a test vue file!</span>
        <div style="height:300px;color:#f00"></div>
        <el-button @click="showDia">show</el-button>
        <div style="height:1000px;color:#f00"></div>
        <el-dialog
            :visible.sync="show"
            :append-to-body="true"
            :close-on-click-modal="$root.dialogAutoClose" 
            :close-on-press-escape="$root.dialogAutoClose">
            <div>
                <el-table :data="form">
                    <el-table-column show-overflow-tooltip label="招标需求内容描述/材质工艺等要求/规格型号" width="140px" prop="name">
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data(){
        return {
            show:false,
            form:[
                {
                    'name':"1111111111111111111111111111111111111111111111111111111111111111111111"
                },
                {
                    'name':"1111111111111111111111111111111111111111111111111111111111111111111111"
                }
            ]
                
        }
    },
    created(){
    },
    methods:{
        showDia(){
            this.show = true
        }
    }
}
</script>

<style>
    .test{
            left: 0;
            top: 0;
            width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/test.vue